import { zs } from './zod';

// A blank input arrives as undefined: say "Required" for that too, not zod's type error.
export const nameField = zs.string({ error: 'Required' }).trim().min(1, 'Required').max(200);
